import script from "./Net.vue?vue&type=script&setup=true&lang=js"
export * from "./Net.vue?vue&type=script&setup=true&lang=js"

import "./Net.vue?vue&type=style&index=0&id=111592cc&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111592cc"]])

export default __exports__